import axios from 'axios'
import jwtDecode from 'jwt-decode'

let API_URL = 'https://' + window.location.host + '/api/auth/login'

if (window.location.host === '192.168.21.44:8443') {
  API_URL = 'https://dev.umfrage2023.kur.org/api/auth/login'
}
class AuthService {
  getExpirationTime() {
    const nowSeconds = Math.ceil(Date.now() / 1000)
    return nowSeconds // + secondsAhead
  }
  getLivingData(token) {
    if (token) {
      const payload = jwtDecode(token)
      if (payload.exp > this.getExpirationTime()) {
        return {
          token,
          payload,
        }
      }
      this.logout()
    }
    return null
  }

  getPayload() {
    let user = JSON.parse(localStorage.getItem('user'))
    let livingData = this.getLivingData(user.accessToken)
    if (livingData) {
      return livingData.payload
    } else {
      this.logout()
    }
  }

  login(user) {
    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        return Promise.reject(error)
      },
    )
    return axios
      .post(API_URL, {
        user: user,
      })
      .then(
        (response) => {
          if (response.data.status == 'success') {
            if (response.data.data.accessToken) {
              let livingData = this.getLivingData(
                response.data.data.accessToken,
              )
              let userData
              if (localStorage.getItem('APP_CONTEXT') == 'UMWA') {
                userData = {
                  type: 'be',
                  accessToken: livingData.token,
                }
              }
              if (localStorage.getItem('APP_CONTEXT') == 'APP') {
                userData = {
                  type: 'fe',
                  accessToken: livingData.token,
                }
              }
              localStorage.removeItem('user')
              localStorage.setItem('user', JSON.stringify(userData))
            }
            return response.data
          } else {
            return response.data
          }
        },
        (error) => {
          console.log(error)
        },
      )
  }
  logout() {
    localStorage.removeItem('user')
    if (localStorage.getItem('APP_CONTEXT') == 'UMWA') {
      window.location.href = '#/backend/login'
    }
    if (localStorage.getItem('APP_CONTEXT') == 'APP') {
      window.location.href = '#/app/login'
    }
  }
}

export default new AuthService()
